// Mock data for Armed Guard Officer.com landing page

export const businessInfo = {
  name: "Armed Guard Officer.com",
  phone: "888-356-0005",
  email: "info@armedguardofficer.com",
  address: {
    street: "12750 NW 17th St Suite 207",
    city: "Miami",
    state: "FL",
    zip: "33182",
    full: "12750 NW 17th St Suite 207, Miami, FL 33182"
  }
};

export const services = [
  {
    id: 1,
    title: "Commercial Armed Security",
    description: "Protect your business assets with highly trained armed officers providing 24/7 surveillance and threat deterrence.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Residential & HOA Protection",
    description: "Secure your community with professional armed guards ensuring peace of mind for residents and families.",
    icon: "Home"
  },
  {
    id: 3,
    title: "Event Armed Security",
    description: "Comprehensive security coverage for high-profile events, ensuring safety without compromising guest experience.",
    icon: "Calendar"
  },
  {
    id: 4,
    title: "Executive / VIP Protection",
    description: "Discreet, elite protection services for executives and high-profile individuals requiring personal security.",
    icon: "Shield"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Florida-Based Operations",
    description: "Headquartered in Miami with deep local expertise",
    stat: "100%",
    statLabel: "Florida Focused"
  },
  {
    id: 2,
    title: "Rapid Response & Deployment",
    description: "Fast mobilization across the state when you need it",
    stat: "24/7",
    statLabel: "Availability"
  },
  {
    id: 3,
    title: "Professionally Trained Officers",
    description: "Rigorous training standards exceeding state requirements",
    stat: "500+",
    statLabel: "Trained Officers"
  },
  {
    id: 4,
    title: "Statewide Reach",
    description: "Coverage across all major Florida metropolitan areas",
    stat: "50+",
    statLabel: "Cities Covered"
  }
];

export const floridaCities = [
  "Miami",
  "Orlando",
  "Tampa",
  "Jacksonville",
  "Fort Lauderdale",
  "West Palm Beach",
  "Naples",
  "Boca Raton",
  "Hialeah",
  "St. Petersburg",
  "Tallahassee",
  "Gainesville"
];

export const testimonials = [
  {
    id: 1,
    name: "Michael R.",
    role: "Property Manager",
    company: "Sunrise Commercial Properties",
    content: "Armed Guard Officer.com transformed our building's security. Their officers are professional, alert, and have significantly reduced incidents on our property.",
    rating: 5,
    isPlaceholder: true
  },
  {
    id: 2,
    name: "Sarah L.",
    role: "Event Director",
    company: "Premier Events Miami",
    content: "We've used their event security services for multiple high-profile gatherings. Impeccable service, discrete presence, and absolute professionalism.",
    rating: 5,
    isPlaceholder: true
  },
  {
    id: 3,
    name: "David K.",
    role: "HOA President",
    company: "Palm Bay Estates",
    content: "Our residents feel safer than ever. The armed guards are courteous to homeowners while maintaining vigilant protection of our community.",
    rating: 5,
    isPlaceholder: true
  }
];

export const complianceBadges = [
  {
    id: 1,
    title: "Florida State Licensed",
    description: "Fully compliant with Florida Division of Licensing"
  },
  {
    id: 2,
    title: "Fully Insured",
    description: "Comprehensive liability coverage for complete protection"
  },
  {
    id: 3,
    title: "Background Verified",
    description: "Extensive background checks on all personnel"
  },
  {
    id: 4,
    title: "Continuous Training",
    description: "Ongoing professional development and certification"
  }
];

export const serviceOptions = [
  "Commercial Security",
  "Residential/HOA Security",
  "Event Security",
  "Executive Protection",
  "Security Assessment",
  "Other"
];
